import styled from 'styled-components';
import { Form } from '@unform/web';

export const Conteiner = styled.div`
  display: flex;

  width: 100%;
`;

export const Formulario = styled(Form)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;

  width: 95%;
  margin: auto;
`;

export const ConteinerCampo = styled.div`
  display: flex;
  flex-direction: column;

  width: ${(props) => (props.half ? '47%' : props.$full ? '100%' : '31%')};
  margin: 10px 10px;

  @media (max-width: 1050px) {
    width: 100%;
  }
`;

export const ConteinerCampos = styled.div`
  display: flex;
  gap: 1rem;

  width: 100%;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;

  width: 100%;
  margin-right: 10px;
`;
